import { render, staticRenderFns } from "./ActivitiesOfSeniorRetoucher.vue?vue&type=template&id=201481de&scoped=true&"
import script from "./ActivitiesOfSeniorRetoucher.vue?vue&type=script&lang=js&"
export * from "./ActivitiesOfSeniorRetoucher.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesOfSeniorRetoucher.vue?vue&type=style&index=0&id=201481de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201481de",
  null
  
)

export default component.exports